export default __webpack_public_path__ + "static/media/FO.5953bba5.svg";